import Vue from "vue";

Vue.directive("async-src", {
    inserted: async function (el, binding, node) {
        const src = await binding.value;
        el.setAttribute("src", src);
    },

    update: async function (el, binding, node) {
        const src = await binding.value;
        el.setAttribute("src", src);
    }
});

